import './mobile_list_info_button_component.scss'

import { Controller } from 'stimulus'

export default class extends Controller {
  openMenu () {
    this.mobileListInfoController.open()
  }

  get mobileListInfoController () {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === 'mobile-list-info'
    })
  }
}
